export default __webpack_public_path__ + "static/media/techcrunch-plus.3d2c4866.png";